var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterChatBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 8,
    viewBox: "0 0 28 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.6V0H7V8H13V6.4H8.89474V4.8H13V3.2H8.89474V1.6H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54545 0H0V8H3.54545C4.89895 8 6 6.92341 6 5.6C6 4.98581 5.76251 4.42496 5.37305 4C5.76262 3.57504 6 3.01419 6 2.4C6 1.07659 4.89884 0 3.54545 0ZM3.54545 6.4H1.63636V4.8H3.54545C3.99665 4.8 4.36364 5.15883 4.36364 5.6C4.36364 6.04117 3.99655 6.4 3.54545 6.4ZM3.54545 3.2H1.63636V1.6H3.54545C3.99665 1.6 4.36364 1.95883 4.36364 2.4C4.36364 2.84117 3.99655 3.2 3.54545 3.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 8V1.5894H21V0H14V1.5894H16.625V8H18.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C23.3459 0 22 1.30713 22 2.91391V8H23.6364V6.46358H26.3636V8H28V2.91391C28 1.30713 26.6541 0 25 0ZM26.3636 4.87417H23.6364V2.91391C23.6364 2.18352 24.248 1.5894 25 1.5894C25.752 1.5894 26.3636 2.18352 26.3636 2.91391V4.87417Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterChatBeta);
export default __webpack_public_path__ + "static/media/footer_chat_beta.92c6c00a6738b5d5888a5844e55af4e8.svg";
export { ForwardRef as ReactComponent };